import ProfilePage from "@/features/profile/page";

export default function Page() {
  return (
    <ProfilePage />
  );
}
